import { render, staticRenderFns } from "./Monsters.vue?vue&type=template&id=0cd7c806&"
import script from "./Monsters.vue?vue&type=script&lang=js&"
export * from "./Monsters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports